module.exports = __webpack_public_path__ + "img/37506-139.d1da0fdb.jpg";